import React, { useEffect } from 'react';
import { SiteNav, MinimalFooter } from './shared';
import Seo from './Seo';

function LegalShell({ children, eyebrow, title, lede, active, lastUpdated, seo }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  return (
    <div className="page-enter" data-screen-label={`Legal · ${active}`}>
      {seo}
      <SiteNav />
      <section style={{ padding: 'min(12vh, 120px) 0 64px' }}>
        <div className="shell">
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(220px, 280px) 1fr', gap: 64, alignItems: 'start' }}>
            <div style={{ paddingTop: 20 }}>
              <div className="section-label" style={{ marginBottom: 28 }}>
                <span>{eyebrow}</span>
              </div>
              {lastUpdated && (
                <div
                  style={{
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
                    fontSize: 11,
                    letterSpacing: '0.1em',
                    color: 'var(--charcoal-faint)',
                    textTransform: 'uppercase',
                  }}
                >
                  Stand · {lastUpdated}
                </div>
              )}
            </div>
            <div>
              <h1 className="h-section" style={{ fontSize: 'clamp(36px, 4vw, 56px)', marginBottom: 24, maxWidth: '20ch' }}>
                {title}
              </h1>
              {lede && (
                <p className="lede" style={{ fontSize: 18, maxWidth: '60ch' }}>
                  {lede}
                </p>
              )}
            </div>
          </div>
        </div>
      </section>

      <hr className="hairline" />

      <section style={{ padding: '80px 0 120px' }}>
        <div className="shell">
          <div style={{ display: 'grid', gridTemplateColumns: 'minmax(220px, 280px) 1fr', gap: 64, alignItems: 'start' }}>
            <div />
            <div className="legal-prose">{children}</div>
          </div>
        </div>
      </section>

      <MinimalFooter active={active} />
    </div>
  );
}

export function ImpressumPage() {
  return (
    <LegalShell
      seo={<Seo path="/impressum" title="Impressum — hamba" description="Pflichtangaben und Anbieterkennzeichnung der hamba GmbH, Königstein im Taunus." />}
      active="/impressum"
      eyebrow="Pflichtangaben"
      title="Impressum."
      lede="Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz) sowie § 18 Abs. 2 MStV."
      lastUpdated="05 / MMXXVI"
    >
      <h2>Anbieter</h2>
      <dl className="kv">
        <dt>Firma</dt><dd>hamba GmbH</dd>
        <dt>Anschrift</dt><dd>Villa Regina<br />Limburger Straße 17<br />61462 Königstein im Taunus<br />Deutschland</dd>
        <dt>Telefon</dt><dd>+49 6174 940 30 89</dd>
        <dt>E-Mail</dt><dd><a href="mailto:contact@hambacore.com">contact@hambacore.com</a></dd>
      </dl>

      <h2>Vertretungsberechtigter Geschäftsführer</h2>
      <p>Dr. Frank Balz</p>

      <h2>Registereintrag</h2>
      <dl className="kv">
        <dt>Handelsregister</dt><dd>Amtsgericht Königstein im Taunus</dd>
        <dt>Registernummer</dt><dd>HRB 10635</dd>
      </dl>

      <h2>Umsatzsteuer</h2>
      <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
      DE 336 984 208</p>

      <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
      <p>Dr. Frank Peter Balz<br />hamba GmbH<br />Villa Regina<br />Limburger Straße 17<br />61462 Königstein im Taunus</p>

      <h2>Streitschlichtung</h2>
      <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>. Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
      <p>Die hamba GmbH ist nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

      <h2>Haftung für Inhalte</h2>
      <p>Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
      <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>

      <h2>Haftung für Links</h2>
      <p>Unser Angebot enthält gegebenenfalls Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.</p>

      <h2>Urheberrecht</h2>
      <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung der hamba GmbH.</p>

      <hr />
      <p className="muted" style={{ fontSize: 13 }}>Dieses Impressum gilt ausschließlich für die unter den Domains hambacore.com, hambacore.de und damit verbundene Subdomains erreichbaren Inhalte.</p>
    </LegalShell>
  );
}

export function DatenschutzPage() {
  return (
    <LegalShell
      seo={<Seo path="/datenschutz" title="Datenschutzerklärung — hamba" description="Wie die hamba GmbH personenbezogene Daten verarbeitet — Zwecke, Rechtsgrundlagen, Speicherdauer und Ihre Rechte nach DSGVO." />}
      active="/datenschutz"
      eyebrow="Privacy"
      title="Datenschutzerklärung."
      lede="Information über die Verarbeitung personenbezogener Daten beim Besuch dieser Website sowie bei der Nutzung des Erstanalyse-Formulars gemäß Art. 13, 14 DSGVO."
      lastUpdated="05 / MMXXVI"
    >
      <h2>1. Verantwortlicher</h2>
      <p>Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG) ist:</p>
      <dl className="kv">
        <dt>Firma</dt><dd>hamba GmbH</dd>
        <dt>Anschrift</dt><dd>Villa Regina, Limburger Straße 17, 61462 Königstein im Taunus</dd>
        <dt>Vertretung</dt><dd>Dr. Frank Balz</dd>
        <dt>E-Mail</dt><dd><a href="mailto:contact@hambacore.com">contact@hambacore.com</a></dd>
        <dt>Telefon</dt><dd>+49 6174 940 30 89</dd>
      </dl>

      <h2>2. Datenschutzbeauftragter</h2>
      <p>Wir sind gesetzlich nicht zur Bestellung eines Datenschutzbeauftragten verpflichtet. Datenschutzrechtliche Anfragen richten Sie bitte direkt an die unter Ziffer 1 genannten Kontaktdaten, idealerweise per E-Mail mit dem Betreff „Datenschutz".</p>

      <h2>3. Allgemeines zur Datenverarbeitung</h2>

      <h3>3.1 Grundsätze</h3>
      <p>Wir verarbeiten personenbezogene Daten unserer Website-Besucher und Interessenten ausschließlich, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie zur Anbahnung und Durchführung von Geschäftsbeziehungen erforderlich ist. Eine Verarbeitung erfolgt regelmäßig nur nach Einwilligung der betroffenen Person oder auf Grundlage einer gesetzlichen Erlaubnis.</p>

      <h3>3.2 Rechtsgrundlagen</h3>
      <ul>
        <li>Art. 6 Abs. 1 lit. a DSGVO — Einwilligung (z. B. für Webanalyse, Marketing-Cookies, Meta-Pixel).</li>
        <li>Art. 6 Abs. 1 lit. b DSGVO — Vertrag und vorvertragliche Maßnahmen (z. B. Erstanalyse-Anfrage).</li>
        <li>Art. 6 Abs. 1 lit. c DSGVO — rechtliche Verpflichtung (z. B. handels- und steuerrechtliche Aufbewahrungspflichten).</li>
        <li>Art. 6 Abs. 1 lit. f DSGVO — berechtigtes Interesse (z. B. Server-Logs zur IT-Sicherheit, CRM zur strukturierten Kundenkommunikation).</li>
      </ul>

      <h3>3.3 Speicherdauer und Löschung</h3>
      <p>Personenbezogene Daten werden gelöscht oder anonymisiert, sobald der Zweck der Speicherung entfällt und keine gesetzlichen Aufbewahrungspflichten entgegenstehen. Konkrete Fristen sind bei den einzelnen Verarbeitungsvorgängen unten genannt.</p>

      <h2>4. Server-Logs und Hosting</h2>
      <p>Beim Aufruf der Website erfasst unser Hosting-Anbieter automatisch technische Daten, die Ihr Browser übermittelt. Diese Daten umfassen:</p>
      <ul>
        <li>anonymisierte IP-Adresse,</li>
        <li>Datum und Uhrzeit des Zugriffs,</li>
        <li>Inhalt der Anforderung (konkrete Seite),</li>
        <li>HTTP-Statuscode,</li>
        <li>jeweils übertragene Datenmenge,</li>
        <li>Referrer-URL,</li>
        <li>Browser und Betriebssystem.</li>
      </ul>
      <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (Sicherstellung des Betriebs, Abwehr von Angriffen). Speicherdauer: maximal 30 Tage, sofern kein konkreter Sicherheitsvorfall eine längere Aufbewahrung erfordert.</p>

      <h2>5. Cookies und Consent-Management</h2>

      <h3>5.1 Technisch erforderliche Cookies</h3>
      <p>Wir setzen technisch erforderliche Cookies, die für den Betrieb der Website unverzichtbar sind. Hierzu zählen insbesondere Session-Cookies des Authentifizierungsdienstes Clerk (siehe Ziffer 9) für den geschützten Mandanten-Bereich. Diese Cookies werden auf Grundlage von § 25 Abs. 2 Nr. 2 TDDDG ohne Einwilligung gesetzt.</p>

      <h3>5.2 Einwilligungsbedürftige Cookies und Tags</h3>
      <p>Nicht-essentielle Cookies und Tracking-Technologien (Google Analytics, Google Ads, Meta-Pixel) werden ausschließlich nach Ihrer aktiven Einwilligung über unser Consent-Management-Banner gesetzt. Sie können Ihre Einwilligung jederzeit für die Zukunft widerrufen, indem Sie die Cookie-Einstellungen erneut aufrufen.</p>

      <h2>6. Webanalyse und Marketing</h2>

      <h3>6.1 Google Tag Manager</h3>
      <p>Wir nutzen den Google Tag Manager (Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland), um Tracking-Tags zentral zu verwalten. Der Tag Manager selbst erfasst keine personenbezogenen Daten, lädt aber andere Dienste (siehe 6.2–6.4) nach. Diese Dienste werden erst nach Ihrer Einwilligung aktiviert.</p>

      <h3>6.2 Google Analytics 4</h3>
      <p>Sofern Sie einwilligen, setzen wir Google Analytics 4 (Anbieter: Google Ireland Limited) zur statistischen Auswertung der Websitenutzung ein. Erfasst werden u. a. besuchte Seiten, Verweildauer, Geräteinformationen und gekürzte IP-Adresse. Die IP-Adresse wird vor jeglicher Speicherung anonymisiert. Eine Übermittlung an Google LLC in den USA findet auf Grundlage des EU-US Data Privacy Framework statt. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO. Speicherdauer: 14 Monate.</p>

      <h3>6.3 Google Ads — Conversion-Tracking</h3>
      <p>Sofern Sie einwilligen, messen wir mittels Google Ads Conversion-Tracking, ob ein über eine Google-Ads-Anzeige eingehender Besuch zu einer Erstanalyse-Anfrage geführt hat. Erfasst werden anonymisierte Kennungen. Anbieter, Drittlandsübermittlung und Rechtsgrundlage entsprechen Ziffer 6.2.</p>

      <h3>6.4 Meta-Pixel (Facebook / Instagram)</h3>
      <p>Sofern Sie einwilligen, setzen wir den Meta-Pixel (Anbieter: Meta Platforms Ireland Limited, 4 Grand Canal Square, Dublin 2, Irland) ein, um die Wirksamkeit von Anzeigen auf Facebook und Instagram zu messen und Zielgruppen für künftige Anzeigen aufzubauen. Erfasst werden u. a. Geräte- und Browser-Informationen, besuchte Seiten und Conversion-Ereignisse. Eine Übermittlung an Meta Platforms, Inc. in den USA findet auf Grundlage des EU-US Data Privacy Framework statt. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO. Sie können dem Tracking jederzeit unter <a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer">facebook.com/settings?tab=ads</a> widersprechen.</p>

      <h2>7. Externe Inhalte</h2>

      <h3>7.1 Google Fonts</h3>
      <p>Wir laden Schriftarten („Cormorant Garamond", „Inter") über die Google-Fonts-Server (Google Ireland Limited). Hierbei wird eine Verbindung zu Google hergestellt, wodurch Google Ihre IP-Adresse erfährt. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (einheitliche und ansprechende Darstellung unserer Angebote). Wir prüfen die Umstellung auf lokal gehostete Schriftarten.</p>

      <h3>7.2 Google Maps</h3>
      <p>Auf der Seite „Standort" binden wir eine Karte des Dienstes Google Maps (Google Ireland Limited) ein, um unsere Adresse zu zeigen. Beim Aufruf der Seite übermittelt Ihr Browser Daten an Google, einschließlich IP-Adresse und ggf. Standortinformationen. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (komfortable Auffindbarkeit). Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a>.</p>

      <h2>8. Kontaktaufnahme über das Erstanalyse-Formular</h2>

      <h3>8.1 Verarbeitete Daten und Zwecke</h3>
      <p>Wenn Sie das Erstanalyse-Formular ausfüllen, erheben und verarbeiten wir folgende Angaben:</p>
      <ul>
        <li>Anrede, Vor- und Nachname,</li>
        <li>E-Mail-Adresse, Telefonnummer,</li>
        <li>Angaben zu Ihrer aktuellen Verwaltungslösung, Portfoliogröße (Wohneinheiten) und monatlicher Nettokaltmiete,</li>
        <li>Angaben zu Ihrer Situation, Zielen und bisherigen Lösungsversuchen,</li>
        <li>frei formulierte Angaben im Feld „Erfolgsbild" (optional).</li>
      </ul>
      <p>Zweck der Verarbeitung ist die Vorbereitung und Durchführung der angefragten Erstanalyse sowie die Anbahnung einer möglichen Geschäftsbeziehung. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen).</p>

      <h3>8.2 Versand der Anfrage über EmailJS</h3>
      <p>Der technische Versand der Formulardaten an unsere interne E-Mail-Adresse erfolgt über den Dienst EmailJS (Anbieter: EmailJS, San Francisco, USA). EmailJS leitet die Inhalte des Formulars als E-Mail an uns weiter. Mit EmailJS besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO; die Übermittlung in die USA stützen wir auf Standardvertragsklauseln nach Art. 46 Abs. 2 lit. c DSGVO und das EU-US Data Privacy Framework. Speicherdauer beim Auftragsverarbeiter: bis zum Abschluss des Versands sowie kurze technische Logs.</p>

      <h3>8.3 Strukturierte Anfrageverwaltung über Attio (CRM)</h3>
      <p>Eingehende Anfragen verwalten wir in dem CRM-System Attio (Anbieter: Attio Ltd., London, Vereinigtes Königreich). In Attio speichern wir die im Formular übermittelten Angaben sowie alle weiteren im Rahmen der Kommunikation entstehenden Notizen und Daten, um eine professionelle Bearbeitung Ihrer Anfrage sicherzustellen. Mit Attio besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO. Das Vereinigte Königreich gilt nach Angemessenheitsbeschluss der EU-Kommission als sicheres Drittland (Art. 45 DSGVO).</p>
      <p>Speicherdauer: Daten zu Interessenten, die kein Mandat erteilen, werden spätestens 24 Monate nach dem letzten Kontakt gelöscht, sofern keine längere Aufbewahrung gesetzlich geboten ist. Bei Mandatserteilung gelten die handels- und steuerrechtlichen Aufbewahrungsfristen (in der Regel 6 bzw. 10 Jahre).</p>

      <h2>9. Authentifizierung im Mandanten-Bereich (Clerk)</h2>
      <p>Für den geschützten Mandanten-Bereich („Dashboard") nutzen wir den Authentifizierungsdienst Clerk (Anbieter: Clerk, Inc., San Francisco, USA). Clerk verarbeitet die zur Anmeldung erforderlichen Daten (E-Mail, Passwort-Hash, Session-Token) und setzt hierzu technisch erforderliche Cookies. Eine Übermittlung in die USA erfolgt auf Grundlage von Standardvertragsklauseln und dem EU-US Data Privacy Framework. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Durchführung des Mandantenvertrags).</p>

      <h2>10. Datensicherheit</h2>
      <p>Wir setzen das verbreitete TLS-Verfahren (Transport Layer Security) mit der jeweils höchsten von Ihrem Browser unterstützten Verschlüsselungsstufe ein. Darüber hinaus treffen wir geeignete technische und organisatorische Maßnahmen, um Ihre Daten gegen zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen. Unsere Sicherheitsmaßnahmen werden fortlaufend an die technische Entwicklung angepasst.</p>

      <h2>11. Drittlandsübermittlungen — Übersicht</h2>
      <p>Soweit wir Dienstleister außerhalb der EU/des EWR einsetzen, geschieht die Übermittlung auf folgenden Grundlagen:</p>
      <ul>
        <li><strong>EU/EWR:</strong> Google Ireland Limited (Hosting der Tag-Manager- und Maps-Dienste).</li>
        <li><strong>Vereinigtes Königreich:</strong> Attio Ltd. — Angemessenheitsbeschluss der EU-Kommission (Art. 45 DSGVO).</li>
        <li><strong>USA:</strong> Google LLC, Meta Platforms Inc., EmailJS, Clerk Inc. — EU-US Data Privacy Framework und ergänzend Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO).</li>
      </ul>

      <h2>12. Rechte der betroffenen Person</h2>
      <p>Werden Ihre personenbezogenen Daten verarbeitet, stehen Ihnen folgende Rechte zu:</p>
      <ul>
        <li>Recht auf Auskunft (Art. 15 DSGVO),</li>
        <li>Recht auf Berichtigung (Art. 16 DSGVO),</li>
        <li>Recht auf Löschung (Art. 17 DSGVO),</li>
        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO),</li>
        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO),</li>
        <li>Widerspruchsrecht gegen Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO),</li>
        <li>Recht, eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO).</li>
      </ul>
      <p>Zur Geltendmachung Ihrer Rechte wenden Sie sich formlos an die unter Ziffer 1 genannte Anschrift oder per E-Mail an <a href="mailto:contact@hambacore.com">contact@hambacore.com</a>.</p>

      <h2>13. Beschwerderecht bei einer Aufsichtsbehörde</h2>
      <p>Unbeschadet anderweitiger Rechtsbehelfe steht Ihnen das Recht zu, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Für hamba zuständig ist:</p>
      <dl className="kv">
        <dt>Behörde</dt><dd>Der Hessische Beauftragte für Datenschutz und Informationsfreiheit</dd>
        <dt>Anschrift</dt><dd>Postfach 3163, 65021 Wiesbaden</dd>
        <dt>Website</dt><dd><a href="https://datenschutz.hessen.de" target="_blank" rel="noopener noreferrer">datenschutz.hessen.de</a></dd>
      </dl>

      <h2>14. Aktualität und Änderungen</h2>
      <p>Diese Datenschutzerklärung hat den oben angegebenen Stand. Durch die Weiterentwicklung unserer Website und unserer Angebote oder aufgrund geänderter gesetzlicher Vorgaben kann eine Anpassung notwendig werden. Die jeweils aktuelle Fassung ist auf dieser Seite abrufbar.</p>

      <hr />
    </LegalShell>
  );
}

export function AGBPage() {
  return (
    <LegalShell
      seo={<Seo path="/agb" title="Allgemeine Geschäftsbedingungen — hamba" description="Nutzungsbedingungen der Website hambacore.com und Hinweise zu den Mandatsbedingungen der hamba GmbH." />}
      active="/agb"
      eyebrow="Nutzungs- & Mandatsbedingungen"
      title="Allgemeine Geschäftsbedingungen."
      lede="Diese AGB bestehen aus zwei Teilen. Teil A regelt die Nutzung der Website hambacore.com. Teil B verweist auf die Mandatsbedingungen für ein Immobilienverwaltungs-Mandat, die im Mandatsvertrag individuell ausgehandelt werden."
      lastUpdated="05 / MMXXVI"
    >
      {/* ─── Teil A · Website-Nutzungsbedingungen ──────────────────── */}
      <h2>Teil A · Nutzungsbedingungen für die Website</h2>

      <h3>§ 1 Geltungsbereich und Vertragspartner</h3>
      <p>(1) Diese Nutzungsbedingungen regeln die Nutzung der Website unter <a href="https://hambacore.com">hambacore.com</a> (nachfolgend „Website") sowie aller über die Website angebotenen Inhalte und Funktionen, einschließlich des Erstanalyse-Formulars.</p>
      <p>(2) Anbieter und Betreiber der Website ist die hamba GmbH, Limburger Str. 17, 61462 Königstein im Taunus, vertreten durch den Geschäftsführer Dr. Frank Peter Balz (nachfolgend „hamba" oder „wir").</p>
      <p>(3) Mit dem Aufrufen der Website akzeptieren Besucher diese Nutzungsbedingungen. Wer den Bedingungen nicht zustimmt, ist gebeten, die Website nicht weiter zu nutzen.</p>

      <h3>§ 2 Leistung und Verfügbarkeit</h3>
      <p>(1) Die Website dient der Information über die Leistungen der hamba GmbH sowie der Anbahnung einer Geschäftsbeziehung über das Erstanalyse-Formular. Die Nutzung der Website ist kostenfrei.</p>
      <p>(2) hamba bemüht sich um eine möglichst hohe Verfügbarkeit, übernimmt jedoch keine Gewähr für eine ununterbrochene Erreichbarkeit. Wartungsarbeiten, höhere Gewalt oder technische Störungen können vorübergehende Einschränkungen verursachen.</p>

      <h3>§ 3 Kontaktaufnahme über das Erstanalyse-Formular</h3>
      <p>(1) Über das Erstanalyse-Formular können Interessenten ihre Kontaktdaten sowie Angaben zu ihrem Immobilienportfolio übermitteln, um eine unverbindliche und kostenfreie Erstanalyse anzufragen.</p>
      <p>(2) hamba verarbeitet die übermittelten Angaben ausschließlich zur Vorbereitung und Durchführung der Erstanalyse sowie zur Anbahnung einer möglichen Geschäftsbeziehung. Eine Weitergabe an unbeteiligte Dritte erfolgt nicht.</p>
      <p>(3) Zur strukturierten Verwaltung eingehender Anfragen nutzt hamba das CRM-System <strong>Attio</strong> (Attio Ltd., London, Vereinigtes Königreich). Die Datenverarbeitung in Attio erfolgt auf Grundlage eines Auftragsverarbeitungsvertrags gemäß Art. 28 DSGVO.</p>
      <p>(4) Mit dem Absenden des Erstanalyse-Formulars stimmen Interessenten der vorgenannten Verarbeitung ihrer Daten zu. Die Anfrage selbst ist unverbindlich und begründet keinen Vertrag über Immobilienverwaltungs-Leistungen. Weitere Einzelheiten zur Datenverarbeitung finden sich in der <a href="/datenschutz">Datenschutzerklärung</a>.</p>

      <h3>§ 4 Geistige Eigentumsrechte</h3>
      <p>(1) Sämtliche Inhalte der Website (Texte, Bilder, Grafiken, Layouts, Logos, Marken sowie die der Website zugrundeliegende Software) sind urheberrechtlich geschützt und stehen ausschließlich hamba oder den jeweiligen Lizenzgebern zu.</p>
      <p>(2) Jede über die nach §§ 44a ff. UrhG gestattete bloße Wiedergabe hinausgehende Vervielfältigung, Bearbeitung, Verbreitung oder öffentliche Wiedergabe bedarf der vorherigen schriftlichen Zustimmung von hamba.</p>

      <h3>§ 5 Haftung</h3>
      <p>(1) Die auf der Website bereitgestellten Informationen wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität wird gleichwohl keine Gewähr übernommen, soweit es sich um allgemeine Marktinformationen, beispielhafte Kennzahlen oder Inhalte mit Erläuterungscharakter handelt.</p>
      <p>(2) hamba haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.</p>
      <p>(3) Im Übrigen haftet hamba nur für die Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) und beschränkt auf den vorhersehbaren, vertragstypischen Schaden. Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.</p>

      <h3>§ 6 Externe Links</h3>
      <p>Die Website kann Verlinkungen zu Websites Dritter enthalten. Auf deren Inhalte hat hamba keinen Einfluss; eine Haftung für fremde Inhalte ist ausgeschlossen. Verantwortlich für die verlinkten Inhalte ist jeweils der dortige Anbieter.</p>

      <h3>§ 7 Änderungen dieser Nutzungsbedingungen</h3>
      <p>hamba behält sich vor, diese Nutzungsbedingungen anzupassen, etwa um gesetzlichen Anforderungen zu entsprechen oder die Website weiterzuentwickeln. Die jeweils aktuelle Fassung ist auf dieser Seite einsehbar.</p>

      <h3>§ 8 Anwendbares Recht und Gerichtsstand</h3>
      <p>(1) Diese Nutzungsbedingungen unterliegen dem Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
      <p>(2) Soweit der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen ist, ist ausschließlicher Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit der Nutzung der Website Königstein im Taunus.</p>

      {/* ─── Teil B · Mandatsbedingungen (Hinweis) ─────────────────── */}
      <h2>Teil B · Hinweis zu den Mandatsbedingungen</h2>

      <h3>§ 9 Verhältnis zu den Mandatsbedingungen</h3>
      <p>(1) Diese Nutzungsbedingungen regeln ausschließlich die Nutzung der Website und die Anbahnung der Geschäftsbeziehung. Sie stellen <strong>keinen Vertrag über Immobilienverwaltungs-Leistungen</strong> dar.</p>
      <p>(2) Die vertraglichen Bedingungen für ein konkretes Immobilienverwaltungs-Mandat (nachfolgend „Mandatsbedingungen") werden zwischen hamba und dem Eigentümer im Rahmen des Mandatsvertrags individuell verhandelt und schriftlich vereinbart.</p>

      <h3>§ 10 Gegenstand der Mandatsbedingungen</h3>
      <p>Die Mandatsbedingungen regeln insbesondere:</p>
      <ul>
        <li>Gegenstand des Mandats und Umfang der operativen Verantwortung,</li>
        <li>Umfang und Grenzen der erteilten Vollmacht,</li>
        <li>Vergütung (Einrichtungsgebühr, Jahreshonorar, Sondergebühren),</li>
        <li>Vertragslaufzeit, Verlängerung und Kündigungsfristen,</li>
        <li>Mitwirkungspflichten des Eigentümers,</li>
        <li>Vertraulichkeit und Datenverarbeitung im Rahmen des Mandats,</li>
        <li>Haftung sowie die hierfür unterhaltene Vermögensschaden-Haftpflichtversicherung,</li>
        <li>anwendbares Recht und Gerichtsstand.</li>
      </ul>

      <h3>§ 11 Erstanalyse als Vorvertragsphase</h3>
      <p>Die kostenfreie Erstanalyse dient der wechselseitigen Prüfung, ob ein Mandat sinnvoll und gewünscht ist. Sie verpflichtet weder den Eigentümer noch hamba zum Abschluss eines Mandatsvertrags. Erst mit der beidseitigen Unterzeichnung eines Mandatsvertrags entsteht ein Vertragsverhältnis über Immobilienverwaltungs-Leistungen.</p>

      <hr />
    </LegalShell>
  );
}
